import React from 'react'
class Projects extends React.Component {

    componentDidMount() {
        document.title = "sweaverD.com - Open source projects"
    }


    render = () => {
        return (
            <div className="solo">
                <h1><i className="fa fa-flask"><span>Open-source projects</span></i></h1>
                <div id="projects">

                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/MWgOxgq" target="_blank">Generative CSS Patterns</a></h2>
                        <p>The ultimate pattern generator.  Featuring <a href="https://css-doodle.com" target="_blank">css-doodle</a> and Math.random().</p>
                        <a href="https://codepen.io/sweaver2112/full/MWgOxgq" target="_blank"><img src="public_images/codepens/cssPatterns.png" /></a>
                    </article>
                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/RwbzZzG" target="_blank">The Sorting</a></h2>
                        <p>Visualize and learn quick sort, merge sort, heap sort, shell sort, comb sort, insertion sort, selection sort, and even bubble sort with this chilling new jam, starring Jack Nicholson.</p>
                        <a href="https://codepen.io/sweaver2112/full/RwbzZzG" target="_blank"><img src="public_images/codepens/theSorting.png" /></a>
                    </article>
                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/pMPEVN" target="_blank">Pixel-Grid</a></h2>
                        <p>Every rect has it's day.  SVG animations featuring a bunch of different modes like Ark Starmap, Stained Glass, Act 2: The Chase, The Maze, and many more.</p>
                        <a href="https://codepen.io/sweaver2112/full/pMPEVN" target="_blank"><img src="public_images/codepens/pixelGrid.png" /></a>
                    </article>
                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/WVNvoJ" target="_blank">Grid Jr</a></h2>
                        <p>A spacey musical visualizer built with vanillaJS and the Web Audio API, featuring streams from <a href="https://internet-radio.com" target="_blank">internet-radio.com</a>.</p>
                        <a href="https://codepen.io/sweaver2112/full/WVNvoJ" target="_blank"><img src="public_images/codepens/gridJr.png" /></a>
                    </article>
                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/aejexV" target="_blank">The Unicode Machine</a></h2>
                        <p>A unicode glyph-finder and plaything. Built with <a target="_blank" href="https://github.com/sweaver2112/Enhanced-Unicode-Character-Blocks/">Enhanced Unicode Character Blocks</a>, and featuring every character set under the sun plus a few more, like Halloween, Hearts, Hands, and Emoticons+.</p>
                        <a href="https://codepen.io/sweaver2112/full/aejexV" target="_blank"><img src="public_images/codepens/unicodeMachine.png" /></a>
                    </article>
                    <article>
                        <h2><a href="https://codepen.io/sweaver2112/full/NWKrXmG" target="_blank">Palette Panda</a></h2>
                        <p>A color tool for artists and webmasters.</p>
                        <a href="https://codepen.io/sweaver2112/full/NWKrXmG" target="_blank"><img src="public_images/codepens/palettePanda.png" /></a>
                    </article>
                </div>
            </div>

        )
    }
}
export default Projects
